import visitorApi from '@/services/api/visitor'
import visitorFirebaseApi from '@/services/api/firebase-visitor-history'

const state = {
  isVisitorInfoActive: false,
  visitorPageStep: 1,
  visitorHasPass: false,
  visitorHistoryId: ''
}

export const getters = {
  isVisitorInfoActive: state => state.isVisitorInfoActive,
  visitorPageStep: state => state.visitorPageStep,
  visitorHasPass: state => state.visitorHasPass
}

export const actions = {
  initVisitor ({ dispatch, rootState }, buildingId = rootState.buildings.currentBuilding.objectId) {
    // console.log('Init Visitor!')
    dispatch('setVisitorHasPass', false)
    const isLoggedin = rootState.auth.isLogin
    const requireVisitorData = rootState.buildings.currentBuilding.requireVisitorData
    const requireWhiteListing = rootState.buildings.currentBuilding.requireWhiteListing
    const whiteListV1 = rootState.buildings.currentBuilding.whiteList || []
    const visitorEmail = window.localStorage.getItem(`istaging-building-${buildingId}-visitor-email`)
    const visitorParsedEmail = window.localStorage.getItem(`istaging-building-${buildingId}-visitor-parsed-email`)
    const hasPassWhiteListV1 = whiteListV1.includes(visitorEmail)
    if (requireVisitorData || requireWhiteListing) {
      /* YSL/Celine Use Old WhiteList Auth Logic */
      if (requireWhiteListing && hasPassWhiteListV1) {
        dispatch('closeVisitor')
        visitorFirebaseApi.fetchVisitor(visitorParsedEmail, buildingId)
        return
      }

      /* New WhiteList Login Logic */
      if (!isLoggedin) {
        if (rootState.auth.sessionLoginLoading) {
          setTimeout(() => {
            dispatch('initVisitor', buildingId)
          }, 1000)
          return
        } else {
          return dispatch('showVisitor')
        }
      }

      // if (requireWhiteListing) {
      //   const whitelistUsername = rootState.auth.username.toLowerCase()
      //   const isInWhitelist = rootState.buildings.currentBuilding.whiteList.map(username => username.toLowerCase()).includes(whitelistUsername)
      //   if (!isInWhitelist) {
      //     return dispatch('showVisitor')
      //   }
      // }
    }
    dispatch('closeVisitor')
  },

  showVisitor ({ dispatch }) {
    dispatch('toggleVisitorInfoActive', true)
    dispatch('setScreenReady', false)
    dispatch('setVisitorHasPass', false)
  },

  closeVisitor ({ dispatch, rootState }) {
    let delay = 3500
    if (rootState.app.isAppReady) {
      delay = 0
    }
    window.setTimeout(() => {
      dispatch('setScreenReady', true)
    }, delay)
    setTimeout(() => {
      dispatch('setVisitorHasPass', true)
    }, 2000)
    dispatch('toggleVisitorInfoActive', false)
  },

  async startViewSession ({ dispatch, rootState, commit }) {
    // console.log('Start View Session!')
    const buildingId = rootState.buildings.currentBuilding.objectId
    const response = await visitorApi.startViewSession({
      buildingId
    })
    commit('SET_VISITOR_HISTORY_ID', response.visitorHistoryId)
    dispatch('startRecordVisitorViewSessionSec', buildingId)
  },

  startRecordVisitorViewSessionSec ({ dispatch, rootState }, targetBuildingId) {
    // console.log('Start Record Visitor View Session Sec!')
    const intervalMS = 5000
    window.setTimeout(function repeat () { // beforeunload can't resolve this feature
      if (targetBuildingId !== rootState.buildings.currentBuilding.objectId) return
      dispatch('updateVisitorViewSessionSec')
      window.setTimeout(repeat, intervalMS)
    }, intervalMS)
  },

  updateVisitorViewSessionSec ({ dispatch, commit, state, rootState }) {
    const visitorHistoryId = state.visitorHistoryId
    if (!visitorHistoryId) {
      return
    }
    visitorApi.updateViewSession(visitorHistoryId)
  },

  toggleVisitorInfoActive ({ commit }, bool = false) {
    commit('TOGGLE_VISITOR_INFO_ACTIVE', bool)
  },

  setVisitorPageStep ({ commit }, step = 1) {
    commit('SET_VISITOR_PAGE_STEP', step)
  },

  setVisitorHasPass ({ commit }, bool = false) {
    commit('SET_VISITOR_HAS_PASS', bool)
  }
}

export const mutations = {
  TOGGLE_VISITOR_INFO_ACTIVE (state, bool = false) {
    state.isVisitorInfoActive = bool
  },

  SET_VISITOR_PAGE_STEP (state, step = 1) {
    state.visitorPageStep = step
  },

  SET_VISITOR_HAS_PASS (state, bool = false) {
    state.visitorHasPass = bool
  },

  SET_VISITOR_HISTORY_ID (state, value) {
    state.visitorHistoryId = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
